import { Component } from "react"

export default class GlobalEscapeHandle extends Component {
  componentDidMount() {
    document.addEventListener(`keydown`, this.handleEscape)
  }

  componentWillUnmount() {
    document.removeEventListener(`keydown`, this.handleEscape)
  }

  handleEscape = event => {
    const { onEscapePress } = this.props

    if (event.keyCode === 27) {
      onEscapePress(event)
    }
  }

  render() {
    return null
  }
}
